import { Component, OnInit } from '@angular/core';
import { ActivityLogsService } from '../services/activity-logs.service';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css']
})
export class ReportsComponent implements OnInit {

  constructor(private activityLogsService: ActivityLogsService) {
    this.activityLogsService.logPageVisit('reports').subscribe();
  }

  ngOnInit(): void {
  }

}
